<!-- eslint-disable vue/v-on-event-hyphenation -->
<template>
  <div class="wrap">
    <div class="board">
      <div class="key_visual addImg down">
        <div class="container">
          <p>다운로드</p>
        </div>
      </div>

      <div class="download_contents">
        <div class="container">
          <div class="section_title">
            <p>다운로드</p>
            <span>
              설치 전 PC 여유 공간을 2GB이상 확보해주시기 바라며, 다운로드 또는
              설치에 오류가 있을 경우에는 서비스 이용 문의를 이용해주세요.
            </span>
          </div>

          <div class="table_area">
            <p>최소사양 & 권장사양 안내</p>
            <div>
              <table>
                <colgroup>
                  <col width="160px" />
                  <col width="452px" />
                  <col width="452px" />
                </colgroup>
                <thead>
                  <tr>
                    <th></th>
                    <th>최소사양</th>
                    <th>권장사양</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>OS</th>
                    <td colspan="2">Windows® 10 64-bit</td>
                  </tr>
                  <tr>
                    <th>CPU</th>
                    <td colspan="2">
                      Intel® Core™ i5 또는 AMD Ryzen™ R5 1600
                    </td>
                  </tr>
                  <tr>
                    <th>RAM</th>
                    <td>8GB RAM</td>
                    <td class="border_left">8GB RAM 또는 그 이상</td>
                  </tr>
                  <tr>
                    <th>VGA</th>
                    <td>NVIDIA® GeForce® GTX 760</td>
                    <td class="border_left">
                      NVIDIA® GeForce® GTX 1060 또는 그 이상
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="btn_area">
              <a download class="gtm_down" @click="download">다운로드</a>
              <span>・현재 Windows OS만 지원합니다. </span>
            </div>
          </div>
          <div class="Modals">
            <ModalConfirm
              @update:isOpen="updateStatus"
              :confirmMsg="errMsg"
              :isOpen="errStatus"
              :downloadChk="FileDowload"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/order
import { dowloadFile } from '../api/download'
import { ref, onMounted } from 'vue'
import { useCookies } from 'vue3-cookies'
import ModalConfirm from '../components/ModalConfirm.vue'

export default {
  name: 'DownloadViews',
  components: {
    ModalConfirm,
  },
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)
    const FileDowload = ref('')

    // console.log(errMsg, errStatus);

    const { cookies } = useCookies()
    const file = ref('') // ref 사용

    const getAcc = cookies.get('access_token')
    const download = async () => {
      if (getAcc === null) {
        FileDowload.value = 'mvLogin'
        errStatus.value = true
        errMsg.value = '로그인이 필요합니다. 로그인 하시겠습니까?'
      } else {
        try {
          const downloadedFile = await dowloadFile()
          file.value = downloadedFile // ref에 할당
          window.location.href = file.value
        } catch (err) {
          console.log(err)
        }
      }
    }

    const updateStatus = () => {
      errStatus.value = false
    }
    onMounted(() => {
      // eslint-disable-next-line no-unused-expressions
      getAcc
    })
    return {
      errMsg,
      errStatus,
      FileDowload,

      file,
      download,
      updateStatus,
    }
  },
}
</script>
